import { Component, inject, OnInit, output, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GoliathCoreEnumerationTypeStore, SharedModule } from '@digiwall/goliath-core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface VatCodeComputationConfirmationResult {
  allowComputation: boolean;
  evaluateArticlePrices: boolean;
}

@Component({
  selector: 'document-vat-code-computation-dialog',
  templateUrl: './doc-vat-code-computation-dialog.component.html',
  imports: [SharedModule],
})
export class DocVatCodeComputationDialogComponent implements OnInit {
  protected coreEnumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);

  vatSystemId = signal<string>('');

  vatCodeComputationConfirmed = output<VatCodeComputationConfirmationResult>();

  protected form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    protected modal: NgbActiveModal,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  protected confirm() {
    this.form.markAllAsTouched();
    if (!this.form.valid) return;

    this.modal.close();
    this.vatCodeComputationConfirmed.emit({
      allowComputation: true,
      evaluateArticlePrices: this.form.get('evaluateArticlePrices')?.value,
    });
  }

  private initForm() {
    this.form = this.formBuilder.group({
      evaluateArticlePrices: [false, [Validators.required]],
    });
  }
}
